import * as React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import {
    closeTabRef,
    VerificationService,
    setRef,
    setFocus,
} from '@sheerid/jslib';
import { LogoComponent } from '../LogoComponent/LogoComponent';
import { redirect } from '../../lib/utils/browser';


interface StepSuccessProps {
    verificationService: VerificationService;
}

const StepSuccessComponent = ({ verificationService }: StepSuccessProps) => {
    // Close any open tab for SSO login
    closeTabRef();

    const hasLogo = verificationService.programTheme.logoUrl ? true : false;
    const redirectPrincessHomepage = 'https://www.princess.com/';
    const redirectCruiseSearch = 'https://www.princess.com/cruise-search/cruises';

    React.useEffect(() => {
        setFocus('sidHeaderTitle');
    });

    return (
        <div id="sid-step-success" className="sid-l-container" role="main" tabIndex={-1} aria-labelledby="sidHeader">
            <div className="sid-header sid-l-horz-center sid-l-space-top-md" id="sidHeader">
                <div className="sid-l-horz-center">
                    { hasLogo ?
                        <LogoComponent verificationService={verificationService} />
                        :
                        <img
                            className="sid-l-lead-image"
                            alt="design element"
                            src="https://assets-resources.sheerid.com/common/images/2018/icons/circle-check.svg"
                        />
                    }
                </div>
                <div className="sid-header__title sid-l-horz-center sid-l-space-top-md" tabIndex={0} role="alert">
                    <h1 role="status" aria-live="assertive" ref={heading => setRef('sidHeaderTitle', heading as HTMLHeadingElement)} tabIndex={-1}>
                        <FormattedHTMLMessage id="step.success.title" defaultMessage="Success! You've been verified." />
                    </h1>
                </div>
                <div className="sid-header__subtitle sid-l-horz-center sid-l-two-thirds-width" role="status">
                    <h2>
                        <FormattedHTMLMessage id="step.success.subtitle" defaultMessage={
                            `We verified your eligibility for the
                            special offer you requested`
                        } />
                    </h2>
                </div>

                <div className="sid-submit sid-success-cruise-personalizer-button sid-l-space-top-md">
                    <button
                        onClick={() => redirect(redirectPrincessHomepage)}
                        className="sid-btn sid-btn--dark"
                    >
                        <FormattedHTMLMessage id="step.success.redirectCruisePersonalizer" defaultMessage="Continue to Princess Cruises" />
                    </button>
                </div>
            </div>

            <div className="sid-success-body sid-success-body__one sid-l-horz-center sid-l-space-top-lg sid-h-small-text">
                <FormattedHTMLMessage id="step.success.verificationOnly"
                    defaultMessage={`
                        SheerID handles verification only. <br>
                        Now that you've been approved, please review the
                        Princess military benefit program
                        <a href="https://www.princess.com/military_benefit_program/">terms and conditions</a>.
                    `}
                />
            </div>
        </div>
    );
};

export { StepSuccessComponent };
